/**
 * Whether an item's File tab shows the panel beside its file (issues, reviews; later a document's formatting), kept in
 * this browser: hidden, the file takes the page's whole width.
 */

import { signal } from "@preact/signals";
import { store, stored } from "./storage.ts";

const KEY = "revisa.item.side";

export const sideShown = signal(stored(KEY) !== "0");

export function setSideShown(on: boolean): void {
  sideShown.value = on;
  store(KEY, on ? null : "0");
}
